<template>
    <div class="data-center">
        <p class="alert alert-warning">提示：本页面提供的数据仅供商户作为调整经营策略参考，不作为结款与验证的准确依据</p>
        <form class="form-horizontal">
            <div class="form-group">
                <label class="col-item control-label">
                    <strong>选择时间：</strong>
                </label>
                <div class="col-item">
                    <v-datepicker :message="startTime" v-model="startTime" :options="timeOption"></v-datepicker>
                </div>
                <div class="col-item margin-top">
                    ~
                </div>
                <div class="col-item">
                    <v-datepicker :value="endTime" v-model="endTime" :options="timeOption"></v-datepicker>
                </div>
                <button class="btn btn-primary" v-on:click="getGtyData" :disabled="buttonDisable">查询</button>
                <span style="color:red;">{{intro}}</span>
            </div>
        </form>
        <h2>经营关键指标</h2>
        <div class="box-container">
            <div class="half-container">
                <div class="item-container">
                    <div class="item">
                        <div class="item-content">
                            <div>
                                <p>销量</p>
                                <p class="quantity">{{formData.totalSoldCount}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="half-container">
                <div class="item-container">
                    <div class="item">
                        <div class="item-content">
                            <div>
                                <p>销售额(元)</p>
                                <p class="quantity">{{formData.totalSales}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h2>运营数据曲线</h2>
        <div class="data-container margin-top">
            <h3 class="projectLink">
                <router-link :to="{ name: 'gtyProgramData'}">查看项目数据</router-link>
            </h3>
            <div class="data-type-container">
                <div>
                    <div class="data-reason">
                        <div class="button-item" :class="{'activeButton': filter == 'soldCount'}" v-on:click="changeFilter('soldCount')">
                            <div>
                                <p>销量</p>
                            </div>
                        </div>
                    </div>
                    <div class="data-reason">
                        <div class="button-item" :class="{'activeButton': filter == 'sales'}" v-on:click="changeFilter('sales')">
                            <div>
                                <p>销售额(元)</p>
                            </div>
                        </div>
                    </div>
                    <div class="data-reason">
                        <div class="button-item" :class="{'activeButton': filter == 'rejectRatio'}" v-on:click="changeFilter('rejectRatio')">
                            <div>
                                <p>商家拒单率</p>
                            </div>
                        </div>
                    </div>
                    <div class="data-reason">
                        <div class="button-item" :class="{'activeButton': filter == 'refundRatio'}" v-on:click="changeFilter('refundRatio')">
                            <div>
                                <p>用户退款率</p>
                            </div>
                        </div>
                    </div>
                    <div class="data-reason">
                        <div class="button-item" :class="{'activeButton': filter == 'payRatio'}" v-on:click="changeFilter('payRatio')">
                            <div>
                                <p>访购率</p>
                            </div>
                        </div>
                    </div>
                    <div class="data-reason">
                        <div class="button-item" :class="{'activeButton': filter == 'uv'}" v-on:click="changeFilter('uv')">
                            <div>
                                <p>访客数</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="charts" class="charts">

                </div>
            </div>
        </div>
    </div>
</template>
<style lang="postcss">
.data-center {
    padding: 20px;
    .alert {
        padding: 10px;
        margin-bottom: 20px;
        border: 1px solid transparent;
        border-radius: 0;
        font-size: 14px;
    }
    .alert-warning {
        background-color: #fff7e5;
        border-color: #ffd98c;
        color: #666;
    }
    .form-horizontal {
        margin-top: 30px;
        .col-item {
            position: relative;
            min-height: 1px;
            padding-left: 15px;
            padding-right: 15px;
            display: inline-block;
        }
    }
    .box-container {
        overflow: hidden;
        display: flex;
        .half-container {
            padding-right: 20px;
            flex: 1.8;
        }
        .item-container {
            display: flex;
            .item {
                flex: 1;
                margin-right: 10px;
                .item-content {
                    border: 1px solid #ccc;
                    height: 130px;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    p {
                        margin: 0;
                    }
                    .quantity {
                        font-size: 26px;
                    }
                }
                .intro {
                    margin-top: 20px;
                }
            }
        }
    }

    .data-container {
        border: 1px solid #ccc;
        border-radius: $radius;
        margin-top: 30px;
        padding: 20px;
        .projectLink {
            margin-top: 30px;
            float: right;
        }
        .showIntro {
            margin-top: 20px;
        }
        .intros {
            line-height: 2;
        }
        .data-type-container>div {
            display: flex;
            margin-top: 20px;
        }
        .data-reason {
            cursor: pointer;
            display: flex;
            margin-right: 20px;
            .activeButton {
                background: #3dc6b6;
                color: #fff;
            }
            .reason-item {
                display: flex;
                height: 80px;
                width: 150px;
                border: 1px solid #ccc;
                align-items: center;
                justify-content: center;
                text-align: center;
                p {
                    margin: 0;
                }
                .quantity {
                    font-size: 26px;
                }
            }
            .button-item {
                display: flex;
                height: 50px;
                width: 90px;
                border: 1px solid #ccc;
                align-items: center;
                justify-content: center;
                text-align: center;
                p {
                    margin: 0;
                }
                .quantity {
                    font-size: 26px;
                }
            }
        }
        .charts {
            height: 240px;
        }
    }
}
</style>
<script>
import { getGtyData } from 'api/gtyDataCenter.js';
import { formatDate as formdate } from 'helpers/formatDate.js';
import floatToPercent from 'filters/toPercent.js';
export default {
    data() {
        return {
            startTime: this.getFormateDate(new Date((new Date().valueOf() - 8 * 24 * 60 * 60 * 1000))),
            endTime: this.getFormateDate(new Date((new Date().valueOf() - 24 * 60 * 60 * 1000))),
            noData: true,
            formData: {},
            dataList: [],
            intro: '',
            buttonDisable: false,
            filter: 'soldCount',
            legendName: {
                'soldCount': '销量',
                'sales': '销售额（元）',
                'payRatio': '访购率',
                'refundRatio': '用户退款率',
                'rejectRatio': '商家拒单率',
                'uv': '访客数'
            },
            timeOption: {
                onChange: (date) => {
                    this.$nextTick(
                        I => {
                            if (this.startTime && this.endTime) {
                                if (this.endTime > this.getFormateDate(new Date((new Date().valueOf() - 24 * 60 * 60 * 1000)))) {
                                    this.intro = "结束时间应选在昨天之前";
                                }
                                else if (this.startTime > this.endTime) {
                                    this.intro = "结束时间应大于开始时间";
                                }
                                else if (this.getFormateDate(new Date((new Date(this.endTime).valueOf() - 90 * 24 * 60 * 60 * 1000))) > this.startTime) {
                                    this.intro = "开始与结束时间间隔需小于90天";
                                }
                                else if (this.startTime < this.getFormateDate(new Date((new Date().valueOf() - 90 * 24 * 60 * 60 * 1000))) || this.endTime < this.getFormateDate(new Date((new Date().valueOf() - 90 * 24 * 60 * 60 * 1000)))) {
                                    this.intro = "请选择最近3个月内数据";
                                }
                                else {
                                    this.intro = "";
                                    this.buttonDisable = false;
                                }
                                if (this.intro) {
                                    this.buttonDisable = true;
                                }
                            }
                        }
                    )
                }
            },
            options: {
                tooltip: {
                    show: true
                },
                legend: {
                    data: ['销量']  // 数据属性
                },
                xAxis: [{
                    type: 'category',
                    boundaryGap: false,
                    data: [], // X坐标内容
                    color: '#000',
                    axisLine: {
                        lineStyle: {
                            color: '#000'
                        }
                    }
                }],
                yAxis: [{
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#000'
                        }
                    },
                    axisLabel: {
                    }
                }],
                series: [{
                    'name': '销量',
                    'type': 'line',
                    'data': [],  // 数据
                    'symbolSize': 4,
                    'symbol': 'emptyCircle'
                }],
                itemStyle: {
                    width: 2,
                    emphasis: {
                        borderWidth: 2,
                        borderColor: '#000'
                    },
                    normal: {
                        areaStyle: {
                            color: '#ff9200'
                        }
                    }
                }
            }
        }
    },
    created: function() {
        this.getGtyData();
    },
    methods: {
        getGtyData: function() {
            getGtyData({
                startTime: this.startTime,
                endTime: this.endTime,
            }).then((response) => {
                if (response.status === 0 && response.data) {
                    this.datalist = response.data.details;
                    this.formData = response.data;
                    let arr = this.formatData(this.datalist);
                    this.options.xAxis[0].data = arr.xAxisData;
                    this.options.series[0].data = arr.seriesData[this.filter];
                    this.charts.setOption(this.options);
                }
            }).catch((error) => {
                this.alert(error);
            })
        },
        alert(message) {
            this.$alert({
                title: '提示',
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        getFormateDate(date) {
            return this.formdate(date, 'yyyy-MM-dd');
        },
        toPercent(value) {
            return floatToPercent(value);
        },
        formdate(time) {
            var date = new Date(time);
            return formdate(date, 'yyyy-MM-dd')
        },
        changeFilter(filter) {
            this.filter = filter;
            if (filter === 'rejectRatio' || filter === 'refundRatio' || filter === 'payRatio') {
                this.options.yAxis[0].axisLabel.formatter = '{value} %';
            } else {
                this.options.yAxis[0].axisLabel.formatter = '{value}';
            }
            this.options.series[0].data = this.formatData(this.datalist).seriesData[filter];
            this.options.legend.data[0] = this.options.series[0].name = this.legendName[filter];
            this.charts.setOption(this.options);
        },
        drawPolyLine(id) {
            this.charts = echarts.init(document.getElementById(id));
            this.charts.setOption(this.options);
        },
        formatData(data) {
            if (!data || !Array.isArray(data)) {
                return;
            }
            let i;
            let l;
            var xAxisData = [];
            var seriesData = {};
            for (i = 0, l = data.length; i < l; i++) {
                xAxisData.push(this.getFormateDate(data[i].date));
                let item = data[i];
                let _this = this;
                Object.keys(item).forEach(function(key) {
                    let val = item[key];
                    if (!seriesData[key]) {
                        seriesData[key] = [];
                    }
                    if (key === 'rejectRatio' || key === 'refundRatio' || key === 'payRatio') {
                        if (val) {
                            val = _this.toPercent(val);
                        }
                        else {
                            val = 0;
                        }

                    }
                    seriesData[key].push(val);
                });
            }
            return {
                xAxisData: xAxisData,
                seriesData: seriesData
            };
        }

    },
    mounted() {
        this.$nextTick(function() {
            this.drawPolyLine('charts');
        })
    },
}
</script>



// WEBPACK FOOTER //
// operationData.vue?73b63b12